'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var defaultOptions = {
    reconnectTimings: [1000, 5000, 10000, 60000, 120000]
};

var _class = function () {
    function _class(url) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, _class);

        this.stream = null;
        this.url = url;
        this.options = Object.assign({}, defaultOptions, options);

        this._connect();

        return this;
    }

    _createClass(_class, [{
        key: 'close',
        value: function close() {
            this._streamConnectionClosedCorrectly = true;

            if (this.isOpen()) {
                this.stream.close();
            }

            return this;
        }
    }, {
        key: 'onmessage',
        value: function onmessage(callback) {
            this._onMessage = callback;
        }
    }, {
        key: 'onopen',
        value: function onopen(callback) {
            this._onOpen = callback;
        }
    }, {
        key: 'onclose',
        value: function onclose(callback) {
            this._onClose = callback;
        }
    }, {
        key: 'onerror',
        value: function onerror(callback) {
            this._onError = callback;
        }
    }, {
        key: 'send',
        value: function send(data) {
            try {
                data = JSON.stringify(data || {});
            } catch (e) {
                data = '{}';
            }

            if (this.isOpen()) {
                this.stream.send(data);
            }

            return this;
        }
    }, {
        key: '_connect',
        value: function _connect() {
            var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

            if (this.isAvailable()) {
                this.stream = new WebSocket(url);
                this.stream.onmessage = this._handleMessage.bind(this);
                this.stream.onopen = this._handleOpen.bind(this);
                this.stream.onclose = this._handleClose.bind(this);
                this.stream.onerror = this._handleError.bind(this);
            } else {
                if (process && process.env.NODE_ENV !== 'production') {
                    console.log('WebSocket: is not defined');
                }
            }

            return this;
        }
    }, {
        key: '_reconnect',
        value: function _reconnect() {
            if (!this._reconnectTimings) {
                this._reconnectTimings = [].concat(this.options.reconnectTimings);
                this._reconnect();
            } else {
                setTimeout(this._connect.bind(this), this._reconnectTimings.unshift());
            }

            return this;
        }
    }, {
        key: 'isOpen',
        value: function isOpen() {
            return this.stream && this.stream.readyState === 1;
        }
    }, {
        key: 'isClosed',
        value: function isClosed() {
            return this.stream && this.stream.readyState === 3;
        }
    }, {
        key: 'isClosing',
        value: function isClosing() {
            return this.stream && this.stream.readyState === 2;
        }
    }, {
        key: 'isConnecting',
        value: function isConnecting() {
            return this.stream && this.stream.readyState === 0;
        }
    }, {
        key: 'isAborted',
        value: function isAborted() {
            return this._streamConnectionClosedCorrectly !== true;
        }
    }, {
        key: 'isAvailable',
        value: function isAvailable() {
            return typeof window['WebSocket'] !== 'undefined';
        }
    }, {
        key: '_handleClose',
        value: function _handleClose(event) {
            if (this.isAborted()) {
                this._reconnect();
            } else {
                if (typeof this._onClose === 'function') {
                    this._onClose(event);
                }
            }
        }
    }, {
        key: '_handleMessage',
        value: function _handleMessage(event) {
            if (typeof this._onMessage === 'function') {
                this._onMessage(event);
            }
        }
    }, {
        key: '_handleOpen',
        value: function _handleOpen(event) {
            if (typeof this._onOpen === 'function') {
                this._onOpen(event);
            }
        }
    }, {
        key: '_handleError',
        value: function _handleError(event) {
            if (typeof this._onError === 'function') {
                this._onError(event);
            }
        }
    }]);

    return _class;
}();

exports.default = _class;